<template>
  <div class="tips">
    <div class="tips-title" v-show="!isShowTips" @click="openTips">
      <span class="tips-title-no">不会？</span>
      查看提示
      <img src="../images/lookTips.png" class="look-tips" alt="">
    </div>
    <div class="look-title" v-show="isShowTips">已查看（{{ curStep + 1 }}/{{prompts.length}}）</div>
    <div class="step-content" v-for="(item, index) in tipsCotext"
     v-show="item.isClick" :key="index" v-katexUbb="promptText(index + 1, item.name)">

    </div>
    <p class="next-step-btn" v-show="isShowStep" @click="nextTips">下一步提示</p>
  </div>
</template>
<script>
export default {
  name: 'dd-footer',
  props: {
    prompt: Array,
  },
  computed: {

  },
  data() {
    return {
      isShowTips: false,
      prompts: this.prompt,
      tipsCotext: [],
      curStep: 0,
      isShowStep: false,
    };
  },
  mounted() {
  },
  created() {
    // eslint-disable-next-line no-unused-vars
    this.prompts.forEach((item, index) => {
      this.tipsCotext.push({
        name: item,
        isClick: false,
      });
    });
  },
  methods: {
    promptText(num, name) {
      return `第${num}步：${name}`;
    },
    openTips() {
      this.isShowTips = true;
      this.$set(this.tipsCotext[this.curStep], 'isClick', true);
      if (this.tipsCotext.length > 1) this.isShowStep = true;
      this.$emit('getSteps', 1);
    },
    nextTips() {
      // eslint-disable-next-line no-plusplus
      this.curStep++;
      if (this.curStep > this.tipsCotext.length - 1) {
        return;
      }
      // eslint-disable-next-line eqeqeq
      if (this.curStep == this.tipsCotext.length - 1) this.isShowStep = false;
      this.$set(this.tipsCotext[this.curStep], 'isClick', true);

      this.$emit('getSteps', this.curStep + 1);
    },
  },
};
</script>
<style lang="scss" scoped>
  .tips{
    width: 370px;
    margin-left: 18px;
    .tips-title {
      width: 150px;
      font-size: 14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:#0089FF;
      .tips-title-no{
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
      .look-tips{
        width: 14px;
        height: 14px;
        position: relative;
        top: -2px;
      }
    }
    .look-title {
      font-size: 14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(50,150,250,1);
      line-height:36px;
      // margin-top: 24px;
    }
    .step-content {
      font-size:16px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(17,31,44,0.56);
      line-height:34px;
      margin-top: 24px;
    }
    .next-step-btn {
      width: 140px;
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(50,150,250,1);
      line-height:36px;
      margin-top: 24px;
    }
  }
</style>
